import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgxDnDModule } from '@swimlane/ngx-dnd';
import { WondaComponent } from '@app/main/wonda/wonda.component';
import { AuthGuard } from '@app/guards/auth.guard';
import { RootRedirectGuard } from '@app/guards/root-redirect.guard';
import { InvitationModule } from '@app/main/invitation/invitation.module';
import { InvitationComponent } from '@app/main/invitation/invitation.component';
import { AccountEditorModule } from '@app/account-editor/account-editor.module';
import { AccountEditorComponent } from '@app/account-editor/account-editor.component';
import { HubEditorModule } from '@app/main/hub/hub-edit/hub-edit.module';
import { ErrorComponent } from '@app/main/error-page/error.component';
import { ErrorModule } from '@app/main/error-page/error.module';
import { CourseViewModule } from '@app/main/apps/course-view/course-view.module';
import { PlayerViewModule } from '@app/player-view/player-view.module';
import { CurrentContextResolver } from '@app/context-resolver/context-resolver';
import { SpaceHubMatchGuard } from '@app/guards/spaceHubMatchGuard';
import { RedirectGuard } from '@app/guards/redirect.guard';

const routes = [
  {
    path: 'account',
    component: AccountEditorComponent,
    canActivate: [AuthGuard],
    resolve: { context: CurrentContextResolver }
  },
  {
    path: 'plans',
    canActivate: [AuthGuard],
    loadChildren: () => import('@app/stripe/plans.module').then((m) => m.PlansModule)
  },
  {
    path: 'hubedit/:urlTitle',
    redirectTo: ':urlTitle'
  },
  {
    path: 'error',
    component: ErrorComponent
  },
  {
    path: 'discover',
    redirectTo: ''
  },
  {
    path: ':urlTitle/:lsId/analytics',
    redirectTo: 'analytics/:urlTitle/:lsId'
  },
  {
    path: ':urlTitle/:lsId/courses/:courseId/analytics',
    redirectTo: 'analytics/:urlTitle/:lsId/courses/:courseId'
  },
  {
    path: 'analytics/:urlTitle',
    canActivate: [AuthGuard, RedirectGuard], // TODO guard
    loadChildren: () => import('@app/main/analytics/analytics.module').then((m) => m.AnalyticsModule),
    resolve: {
      context: CurrentContextResolver
    }
  },
  {
    path: ':urlTitle/:lsId/courses',
    canActivate: [AuthGuard, RedirectGuard],
    loadChildren: () => import('@app/main/apps/course-detail/course-detail.module').then((m) => m.CourseDetailModule),
    resolve: { context: CurrentContextResolver }
  },
  {
    path: 'invitations/:id',
    component: InvitationComponent,
    data: {
      hideTopBar: true,
      noIndex: true
    }
  },
  {
    // Note that this route is the same as for Programs.
    // This one here is tested first because WondaModule is imported before in ProgramModule.
    // By using `canMatch`, they only match if the hub is a space hub.
    path: ':urlTitle',
    canActivate: [AuthGuard, RedirectGuard],
    loadChildren: () => import('@app/main/learnspaces/learnspace.module').then((m) => m.LearnspaceModule),
    resolve: { context: CurrentContextResolver },
    canMatch: [SpaceHubMatchGuard],
    data: {
      noIndex: true
    }
  },

  {
    path: '',
    canActivate: [RootRedirectGuard],
    component: WondaComponent
  }
];

@NgModule({
  declarations: [WondaComponent],
  imports: [
    RouterModule.forChild(routes),
    TranslateModule,
    NgxDnDModule,
    CourseViewModule,
    InvitationModule,
    PlayerViewModule,
    AccountEditorModule,
    ErrorModule,
    HubEditorModule
  ],
  exports: [WondaComponent]
})
export class WondaModule { }
